import { render, staticRenderFns } from "./AddNewDependent.vue?vue&type=template&id=5dde6626&"
import script from "./AddNewDependent.vue?vue&type=script&lang=js&"
export * from "./AddNewDependent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports